namespace TabAurous.Finance {
    export interface ExpenseForm {
        VoucherTypeId: Serenity.IntegerEditor;
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        LedgerId: Serenity.LookupEditor;
        RefNo: Serenity.StringEditor;
        RefDate: Serenity.DateEditor;
        EnteredBy: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchangeRate: Serenity.DecimalEditor;
        Details: ExpenseDetailEditor;
        UserId: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        TotalAmount: Serenity.DecimalEditor;
        Narration: Serenity.StringEditor;
    }

    export class ExpenseForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.Expense';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ExpenseForm.init)  {
                ExpenseForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;
                var w5 = ExpenseDetailEditor;

                Q.initFormType(ExpenseForm, [
                    'VoucherTypeId', w0,
                    'TransDate', w1,
                    'VoucherNo', w2,
                    'LedgerId', w3,
                    'RefNo', w2,
                    'RefDate', w1,
                    'EnteredBy', w2,
                    'CurrencyId', w3,
                    'ExchangeRate', w4,
                    'Details', w5,
                    'UserId', w4,
                    'TaxAmount', w4,
                    'TotalAmount', w4,
                    'Narration', w2
                ]);
            }
        }
    }
}
